import { EventEmitterInterface } from 'pf-frontend-common/dist/module/event/emitter.interface';

import { MyAccountToggleSaveButtonInteractionEvent } from 'common/module/my-account/toggle-save-button/interaction.event';
import { MyAccountToggleSaveButtonInteractionPayloadInterface } from 'common/module/my-account/toggle-save-button/interaction/payload.interface';
import { MyAccountToggleSaveButtonListingContextEnum } from 'common/module/my-account/toggle-save-button/listing-context.enum';
import { StatsServiceInterface } from 'common/service/stats/service.interface';

export class MyAccountToggleSaveButtonStatsStore {
  /**
   * Constructor
   */
  constructor(
    private toggleSaveButtonInteractionService: EventEmitterInterface,
    private statsService: StatsServiceInterface
  ) {}

  /**
   * Init store
   */
  public initialize(): void {
    this.toggleSaveButtonInteractionService.addListener(MyAccountToggleSaveButtonInteractionEvent.save, this.onSave);

    this.toggleSaveButtonInteractionService.addListener(
      MyAccountToggleSaveButtonInteractionEvent.unsave,
      this.onUnsave
    );
  }

  /**
   * Handle save event
   */
  private onSave = (payload: MyAccountToggleSaveButtonInteractionPayloadInterface) => {
    if (payload.listingContext !== MyAccountToggleSaveButtonListingContextEnum.default) {
      return;
    }

    this.statsService.propertySave(parseInt(payload.property.id, 10), payload.statsContext);
  };

  /**
   * Handle unsave event
   */
  private onUnsave = (payload: MyAccountToggleSaveButtonInteractionPayloadInterface) => {
    if (payload.listingContext !== MyAccountToggleSaveButtonListingContextEnum.default) {
      return;
    }

    this.statsService.propertyUnsave(parseInt(payload.property.id, 10), payload.statsContext);
  };
}
